/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import { ToolsetEntry, ToolsetEntry$inboundSchema } from "./toolsetentry.js";

export type ListToolsetsResult = {
  /**
   * The list of toolsets
   */
  toolsets: Array<ToolsetEntry>;
};

/** @internal */
export const ListToolsetsResult$inboundSchema: z.ZodMiniType<
  ListToolsetsResult,
  unknown
> = z.object({
  toolsets: z.array(ToolsetEntry$inboundSchema),
});

export function listToolsetsResultFromJSON(
  jsonString: string,
): SafeParseResult<ListToolsetsResult, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => ListToolsetsResult$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'ListToolsetsResult' from JSON`,
  );
}
